module CompanyPageModel

open Elmish
open Elmish.Bridge
open Model
open Shared
open PortalLibs.Client.Util
open PortalLibs.Shared
open System

type Model =
  { CompanyTabData: CompanyTabRow list option
    Companies: Company list option
    SelectedCompany: Company option
    ExpandedSuperContracts: Map<string option, unit>
    DateRange: DateTime option * DateTime option }

type Msg =
  | CompanyTabData of CompanyTabRow list
  | Companies of Company list
  | SelectedCompanyChanged of Company option
  | DateRangeChanged of DateTime option * DateTime option
  | ExecuteSearch
  | SuperContractToggled of string option

let init () =
  { CompanyTabData = None
    Companies = None
    SelectedCompany = None
    ExpandedSuperContracts = Map.empty
    DateRange = Some(DateTime.Now.AddDays(-30.0)), Some(DateTime.Now.AddDays(1.0))
  },
  Cmd.none

let requestData model =
  if Option.isNone model.CompanyTabData then
    RSCompanyTabQuery None |> Bridge.Send

  if Option.isNone model.Companies then
    RSCompanyTabCompanies |> Bridge.Send


let update msg model =
  match msg with
  | CompanyTabData entries ->
    { model with
        ExpandedSuperContracts = Map.empty
        SelectedCompany =
          if not entries.IsEmpty
             && model.SelectedCompany.IsNone then
            Some
              { Name = entries.Head.CompanyName
                Co = entries.Head.Co }
          else
            model.SelectedCompany
        CompanyTabData = Some entries },
    Cmd.none
  | Companies entries -> { model with Companies = Some entries
                                      SelectedCompany =
                                          if not entries.IsEmpty
                                             && model.SelectedCompany.IsNone then
                                            Some
                                              { Name = entries.Head.Name
                                                Co = entries.Head.Co }
                                          else
                                            model.SelectedCompany }, Cmd.none
  | SelectedCompanyChanged co -> { model with SelectedCompany = co }, Cmd.ofMsg ExecuteSearch
  | DateRangeChanged (fromOpt, toOpt) ->
    { model with
        DateRange = fromOpt, toOpt },
    Cmd.ofMsg ExecuteSearch
  | ExecuteSearch ->
    model.SelectedCompany
    |> Option.iter
         (fun co ->
           let fromOpt, toOpt = model.DateRange

           fromOpt
           |> Option.iter
                (fun dateFrom ->
                  toOpt
                  |> Option.iter
                       (fun dateTo ->
                         RSCompanyTabQuery(Some(co.Co, dateFrom, dateTo))
                         |> Bridge.Send)))

    { model with CompanyTabData = None }, Cmd.none
  | SuperContractToggled super ->
    let contracts =
      if Map.containsKey super model.ExpandedSuperContracts then
        Map.remove super model.ExpandedSuperContracts
      else
        Map.add super () model.ExpandedSuperContracts

    { model with ExpandedSuperContracts = contracts },
    Cmd.none

let getScrollValue () = getTableScrollPos ()

let restoreScrollPos pos = scrollTableToPos pos
